import { PAYMENT_CONTRACTS } from '@/utils/store/getterTypes'

export default {
  [PAYMENT_CONTRACTS] (state) {
    return state.paymentContracts
  }
}
